/// <reference path="FilterPanelTypes.ts" />
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FilterPanel.html?raw';
import on from 'dojo/on';

import FilterPanelOption from '../../../moreCore/UI/FilterPanel/FilterPanelOption';
//import FilterPanelOption = require("../../../moreCore/UI/FilterPanel/FilterPanelOptionV2");
import FilterPanelSection from '../../../moreCore/UI/FilterPanel/FilterPanelSection';
import "../../../moreCore/UI/FilterPanel/FilterPanelSection";

import { FilterPanelTypes, FilterPanelFormat, FilterOptionTypes } from "../../../moreCore/UI/FilterPanel/FilterPanelTypes";
import { isArray } from "dojo/_base/lang";
import "../SelectBox/SelectBox";


class FilterPanel extends compose(_WidgetBaseSP) {
    templateString: any = template;
    //headerBarNode: HTMLDivElement;
    //headerTitleRow: HTMLElement;
    //headerTitle: HTMLSpanElement;
    //filterOptionsContainer: HTMLDivElement;
    //collapseIcon: HTMLElement;
    //collapseContainer: HTMLElement;
    sectionsContainer: HTMLElement;
    hiddenSectionsControlContainer: HTMLElement;
    hiddenSectionsSelectorContainer: HTMLElement;
    hiddenSectionsContainer: HTMLElement;

    private sections: Array<FilterPanelTypes.Section<MdsLax<InstanceType<typeof FilterPanelSection>>>>;
    private _config: FilterPanelTypes.PanelConfig = {
        format: FilterPanelFormat.compact,
        name: "default",
        sections: [],
        sectionSorting: false,
        buttonConfig: null,
        collapsible: false,
        isCollapsed: false,
        title: "?",
    };
    private _displaySettings: FilterPanelTypes.UserDisplaySettings;

    name: string;

    //warningIcon: HTMLElement;
    leftIconNode: HTMLElement;
    buttonConfig: FilterPanelTypes.ButtonConfig = null;
    btnSubmit: HTMLButtonElement;
    buttonContainer: HTMLElement;
    buttonLabel: HTMLElement;
    selectHiddenSections: HTMLElement;// SelectBox;


    //filterOptions: Array<FilterPanelOption>;
    //private sectionData: FilterPanelSection;
    //name: string = "";
    //private rules: FilterSectionRules;
    valid: boolean = true;

    //private _jsonData: object;

    private isReadonly: boolean = false;

    private changeCallback: Function;

    outputFormat: FilterPanelFormat = FilterPanelFormat.compact;

    setConfig(config: FilterPanelTypes.PanelConfig, changeCallback?: (data: any) => any) {
        if (!config) return;
        
        this._config = config;

        

        this.setSectionData(config.sections);

        if (config.name) {
            this.setPanelName(config.name);
        }

        if (typeof (config.sectionSorting) == "boolean") {
            this.enableSectionSorting(config.sectionSorting !== false);
        }

        if (config.hideSectionsIfSingle === true || config.hideSectionsIfSingle === false) {
            this.hideSectionIfSingle(config.hideSectionsIfSingle);
        }

        if (changeCallback) this.changeCallback = changeCallback;
    }
    /**
     * Interner Name für das Filterpanel, löst ein Neuladen der Anzeigeeinstellungen aus dem localstorage aus.
     * @param name neuer, eindeutiger interner Name für das Filterpanel
     * @param bReloadDisplaySettings Wenn false, wird das Laden der Anzeigeeinstellungen verhindert
     */
    setPanelName(name: string, bReloadDisplaySettings: boolean = true) {
        this.name = name;
        if (this.domNode) this.domNode.setAttribute("data-cy", "filterpanel:" + name);
        if (bReloadDisplaySettings != false) {
            let settings = this._loadDisplaySettings();
            if (settings) {
                this.applyDisplaySettings(settings)
            }
        }
    }
    /**
     * Blendet Sortierbuttons für die Filtersections ein oder aus.
     * 
     */
    enableSectionSorting(sortingAllowed: boolean = true) {
        for (let section of this.sections) {
            section.widget.setSortingAllowed(sortingAllowed);
        }

        this._config.sectionSorting = sortingAllowed;
    }

    getData(bForceIfInvalid?: boolean): object {
        if (this.valid != true && bForceIfInvalid !== true) {
            return null;
        }

        let data = [];

        for (let section of this.sections) {
            if (section.widget.getVisibility() === true) {
                data.push(section.widget.getData(this.outputFormat, bForceIfInvalid));
            }
        }

        return data;
    }

    hideSectionIfSingle(bHide: boolean = true) {
        if (this.sections.length == 1 && bHide == true) {
            this.UiModder.domClass.add(this.domNode, "invisibleSections");
            return;
        }

        this.UiModder.domClass.remove(this.domNode, "invisibleSections");
    }

    setAlternativeMandatoryMode(alternativeMode: boolean) {
        let options = this.getFilterOptions();
        for (let option of options) {
            //option.alternativeMandatoryMode = alternativeMode == true;
            option.setAlternativeMandatoryBehaviour(alternativeMode == true);
        }

        this.serializeData();
    }

    setReadonly(bValue?: boolean, targetSectionName?: string) {
        if (bValue !== true && bValue !== false) {
            bValue = true;
        }

        if (!targetSectionName) {
            this.isReadonly = bValue;
        }

        for (let section of this.sections) {
            if (!targetSectionName || section.widget.name == targetSectionName) {
                section.widget.setReadonly(bValue);

                if (targetSectionName) {
                    return;
                }
            }
        }

        if (this.buttonContainer) {
            if (this.isReadonly) {
                this.UiModder.domClass.add(this.buttonContainer, "w3-disabled");
            }
            else {
                this.UiModder.domClass.remove(this.buttonContainer, "w3-disabled");
            }
        }
    }

    getSectionByName(name: string): FilterPanelTypes.Section<MdsLax<InstanceType<typeof FilterPanelSection>>> {
        for (let section of this.sections) {
            if (section.widget.name == name) {
                return section;
            }
        }

        return null;
    }

    addSection(data: FilterPanelTypes.SectionConfig): void {
        let fpSection = new FilterPanelSection();
        fpSection.placeAt(this.sectionsContainer);

        on(fpSection, "keyUp", lang.hitch(this, this._onKeyUp_Section));
        
        let fpData: FilterPanelTypes.Section<MdsLax<InstanceType<typeof FilterPanelSection>>> = {
            config: data,
            widget: fpSection,
            valid: false,
        }

        //this.UiModder.domClass.add(fpSection.domNode, "sectionBG");

        on(fpSection, "serializedData", lang.hitch(this, this._onSerializedSection, fpData));
        on(fpSection, "visibilityChanged", lang.hitch(this, this._onSectionVisibility, fpData));
        on(fpSection, "collapsed", lang.hitch(this, this._onSectionCollapse, fpData));
        on(fpSection, "orderUp", lang.hitch(this, this._onSectionOrder, fpData));
        on(fpSection, "orderDown", lang.hitch(this, this._onSectionOrder, fpData));

        this.sections.push(fpData);

        if (typeof (data.order) != "number") {
            data.order = this.sections.length;
        }


        //this.setSectionData(data);
        fpSection.setSectionData(data);

        if (this._config) {
            fpSection.setSortingAllowed(this._config.sectionSorting === true);
        }

        this._moveSectionByVisibility(fpData);

        this.hideSectionIfSingle(false);
    }

    applyDisplaySettings(settings?: FilterPanelTypes.UserDisplaySettings) {
        
        if (settings) {
            this._saveDisplaySettings(settings);
        } else {
            settings = this._displaySettings;
        }
        
        // aus den gespeicherten displaysettings auslesen, ob die Section in der Vergangenheit ausgeblendet wurde oder nicht
        let visibility = true;
        if (this._displaySettings) {
            for (let entry of this._displaySettings.sections) {
                let section = this.getSectionByName(entry.name);

                if (section) {
                    let data = section.config;

                    if (entry.name == data.name) {
                        //if (data.hideable) {
                        if (false) {
                            if (entry.hidden == "default") {
                                visibility = data.visibleByDefault;
                                if (data.hideable != true || typeof (data.visibleByDefault) != "boolean") {
                                    visibility = true;
                                }
                            } else if (entry.hidden === true || entry.hidden === false) {
                                visibility = !entry.hidden;
                            }

                            data.visibleByDefault = visibility;

                            section.widget.setInvisible(!visibility);
                        }

                        // override: collapsible nicht mehr verwenden.
                        if (typeof (entry.isCollapsed) == "boolean" && data.collapsible === true) {
                        //    section.widget.setCollapsible(data.collapsible, entry.isCollapsed);
                            section.widget.setCollapsible(false, false);
                        }

                        if (typeof (entry.order) == "number") {
                            section.widget.setOrder(entry.order);
                        }
                    }
                }
            }

        }

        if (this._config.sectionSorting) {
            
            this._sortSections();
        }
        //this._serializeDisplaySettings();
    }

    setButtonConfig(data: FilterPanelTypes.ButtonConfig) {

        this.buttonConfig = data;

        this.applyButtonConfig();
    }

    setSectionData(data: FilterPanelTypes.SectionConfig | Array<FilterPanelTypes.SectionConfig>, bSuppressApplySettings: boolean = false): void {
        //console.debug("setSectionData", data);
        let currentDisplaysettings = null;

        if (bSuppressApplySettings != true) {
            currentDisplaysettings = this._loadDisplaySettings();
        }

        if (isArray(data)) {
            for (let section of data) {
                this.setSectionData(section, true);
            }
        } else {
            let existingSection = this.getSectionByName(data.name);
            if (existingSection == null) {
                this.addSection(data);
            }
        }

        if (!bSuppressApplySettings) {
            this.applyDisplaySettings(currentDisplaysettings);
        }
    }
    serializeData(): void {
        for (let section of this.sections) {
            section.widget.serializeData();
        }
    }

    private _onSectionOrder(targetSection: FilterPanelTypes.Section<MdsLax<InstanceType<typeof FilterPanelSection>>>, currentOrder: number) {
        // die Section hat sich ihre Order geändert
        // wir sortieren das Array nach order + userorder
        // dann wird intern gleich nochmal sauber durchgezählt
        this._sortSections();

        this._serializeDisplaySettings();
    }

    private _sortSections() {
        
        if (!this.sections || !this.sections.length) {
            return;
        }
        this.sections.sort(this.compareFunction);
        
        let currentUserOrder = 0;
        let mainItemCount = 0;
        for (let section of this.sections) {
            let isVisible = section.widget.getVisibility();

            if (isVisible) {//&& !isCollapsed) {
                mainItemCount++;
                section.widget.setOrder(currentUserOrder);
                this.UiModder.domConstruct.place(section.widget.domNode, this.sectionsContainer, mainItemCount);
            } else {
                section.widget.setOrder(currentUserOrder);
            }
            currentUserOrder += 100;
        }
    }
    private compareFunction(section1: FilterPanelTypes.Section<MdsLax<InstanceType<typeof FilterPanelSection>>>, section2: FilterPanelTypes.Section<MdsLax<InstanceType<typeof FilterPanelSection>>>) {

        let order2 = section2.widget.getOrder(false);
        let order1 = section1.widget.getOrder(false);



        if (order2 == order1) {
            order2 = section2.config.order;
            order1 = section1.config.order;
        }
       
        let result = order2 - order1;
        
        return result * -1;
    }

    private getDomNodeOrder(section: FilterPanelTypes.Section<MdsLax<InstanceType<typeof FilterPanelSection>>>): number {
        let index = -1;
        
        for (let comparesection of this.sections) {
            if (comparesection.widget.getVisibility() == true) {
                index++;
            }

            if (comparesection.config.name = section.config.name) {
                return index;
            }
        }
        return -1;
    }

    private _moveSectionByVisibility(targetSection: FilterPanelTypes.Section<MdsLax<InstanceType<typeof FilterPanelSection>>>) {

        let targetNode = this.sectionsContainer;

        if (targetSection.widget.getVisibility() === true) {
            
        } else {
            targetNode = this.hiddenSectionsContainer;
        }

        this.UiModder.domConstruct.place(targetSection.widget.domNode, targetNode);

    }
    private _onSectionCollapse(targetSection: FilterPanelTypes.Section<MdsLax<InstanceType<typeof FilterPanelSection>>>, isCollapsed: boolean) {

        //this._moveSectionByVisibility(targetSection);

        //this._sortSections();

        this._serializeDisplaySettings();
    }
    private _onSectionVisibility(targetSection: FilterPanelTypes.Section<MdsLax<InstanceType<typeof FilterPanelSection>>>, isHidden: boolean) {

        this._moveSectionByVisibility(targetSection);

        this._serializeDisplaySettings();
        
        this.serializeData();
    }

    private _onChange_SelectHiddenSection(value) {
        
        let section = this.getSectionByName(value);

        if (section) {
            section.widget.setInvisible(false);
        }
    }

    //private _onClick_AddHiddenSection(evt: MouseEvent) {
    //    //if (evt) evt.stopPropagation();

    //    this.UiModder.domClass.toggle(this.hiddenSectionsSelectorContainer, "w3-hide");
    //}

    private _serializeDisplaySettings() {
        let displaySettings: FilterPanelTypes.UserDisplaySettings = {
            sections: [],
            filterpanelName: this.name
        };
        
        let bContainsHiddenSection = false;
        this.UiModder.domConstruct.empty(this.hiddenSectionsSelectorContainer);
        //this.selectHiddenSections = new SelectBox();
        //this.selectHiddenSections.placeAt(this.hiddenSectionsSelectorContainer, "only");
        //this.selectHiddenSections.setBlankOption("---", this.translations["FilterPanel__hiddenSectionsBlankItem"], false);
        //this.selectHiddenSections.setValue("x", true);
        let order = 0;
        for (let section of this.sections) {
            let sectionSetting: FilterPanelTypes.UserSectionSetting = {
                name: section.config.name,
                order: section.widget.getOrder(),
                hidden: section.widget.getVisibility() !== true,
                isCollapsed: section.widget.getCollapseState() === true
            };

            order++;

            displaySettings.sections.push(sectionSetting);

            if (sectionSetting.hidden == true) {
                bContainsHiddenSection = true;
                //this.selectHiddenSections.addEntry(sectionSetting.name, section.config.sectionLabel, true);
                let selectorDiv = this.UiModder.domConstruct.create("button", {
                    className: "mds-button-base round mds-hover-dark",
                    "innerHTML": section.config.sectionLabel
                }, this.hiddenSectionsSelectorContainer);
                this.UiModder.domConstruct.create("i", { className: "far fa-plus-square", "innerHTML": "&nbsp;" }, selectorDiv, "first");

                on(selectorDiv, "click", lang.hitch(this, this._onChange_SelectHiddenSection, sectionSetting.name));
            }
        }
        
        //this.UiModder.domClass.toggle(this.hiddenSectionsSelectorContainer, "w3-hide", !bContainsHiddenSection);
        this.hideNode(this.hiddenSectionsControlContainer, !bContainsHiddenSection);
        //this.UiModder.domClass.toggle(this.selectHiddenSections.domNode, "w3-hide", !bContainsHiddenSection);
        //this.selectHiddenSections.constructOptions();
        //on(this.selectHiddenSections, "change", lang.hitch(this, this._onChange_SelectHiddenSection));
        this._displaySettings = displaySettings;

        this._saveDisplaySettings();
    }

    private _saveDisplaySettings(data?: FilterPanelTypes.UserDisplaySettings) {

        if (!data) data = this._displaySettings;

        let storedData = this._loadGlobalFilterpanelSettings();
        for (let i = 0; i < storedData.sectionVisibilitySettings.length; i++) {
            let storedPanelSettings = storedData.sectionVisibilitySettings[i];
            if (storedPanelSettings.filterpanelName == this.name) {
                storedData.sectionVisibilitySettings.splice(i, 1);
                break;
            }
        }

        storedData.sectionVisibilitySettings.push(data);
        localStorage.setItem("ego_FilterpanelSettings", JSON.stringify(storedData));

    }

    private _loadGlobalFilterpanelSettings(): FilterPanelTypes.PanelSettingsStorage {
        let rawStoredData = localStorage.getItem("ego_FilterpanelSettings");
        let storedData: FilterPanelTypes.PanelSettingsStorage = null;
        if (rawStoredData) {
            try {
                storedData = JSON.parse(rawStoredData);
            } catch (ex) {
                console.warn("parsing stored filterpanel settings failed!", ex, rawStoredData);;
            }
        }

        if (!storedData) {
            storedData = {
                sectionVisibilitySettings: []
            };
        }

        return storedData;
    }
    private _loadDisplaySettings(): FilterPanelTypes.UserDisplaySettings {
        
        let storedData = this._loadGlobalFilterpanelSettings();
        let knownSettings: FilterPanelTypes.UserDisplaySettings = null;
        let index = -1;
        for (let i = 0; i < storedData.sectionVisibilitySettings.length; i++) {
            let entry = storedData.sectionVisibilitySettings[i];
            if (entry.filterpanelName == this.name) {
                index = i;
                break;
            }
        }

        if (index != -1) {
            knownSettings = storedData.sectionVisibilitySettings[index];
        } else {
            knownSettings = {
                filterpanelName: this.name,
                sections: []
            };
        }

        return knownSettings;
        
    }


    private _onSerializedSection(targetSection: FilterPanelTypes.Section<MdsLax<InstanceType<typeof FilterPanelSection>>>, result: boolean | Object) {
        if (result === false) {
            targetSection.valid = false;
        }
        else {
            targetSection.valid = true;
        }

        this.checkValid();

        if (this._emitDelayHandle != null) {
            clearTimeout(this._emitDelayHandle);
            this._emitDelayHandle = null;
        }

        this._emitDelayHandle = setTimeout(lang.hitch(this, this.emitSerialization), 66);
    }

    _emitDelayHandle: any = null;
    private emitSerialization(): void {  
        let data = this.getData();
        this.emit("serializedData", data);
        this.emit("change", data);
        this._emitDelayHandle = null;

        if (this.changeCallback) this.changeCallback(data);
    }

    private checkValid(): void {
        //console.log("serializeData", this.outputFormat, this.filterOptions);

        var bValid = true;


        for (let section of this.sections) {
            if (section.valid != true) {
                bValid = false;
                break;
            }
        }

        let enabledClasses = "hoverBright accentBG";
        let disabledClasses = "secondaryBG w3-disabled";
        if (this.buttonConfig) {
        //    enabledClasses = this.buttonConfig.buttonClassesEnabled;
        //    disabledClasses += this.buttonConfig.buttonClassesDisabled;
        }

        this.valid = bValid;

        this.UiModder.domClass.toggle(this.domNode, "invalid", !bValid);
        
        if (bValid === true) {
             if (enabledClasses) {
                this.UiModder.domClass.add(this.btnSubmit, enabledClasses);
            }
            if (disabledClasses) {
                this.UiModder.domClass.remove(this.btnSubmit, disabledClasses);
            }

        } else {
            this.emit("serializedData", false);
            if (enabledClasses) {
                this.UiModder.domClass.remove(this.btnSubmit, enabledClasses);
            }
            if (disabledClasses) {
                this.UiModder.domClass.add(this.btnSubmit, disabledClasses);
            }
        }
    }

    getFilterOptionValue(optionname: string): string | boolean | number | Array<string> {
        //console.debug("getFilterOptionValue", optionname, this.filterOptions);
        let filterOption = this.getFilterOptionByName(optionname);

        if (filterOption) {
            return filterOption.getData().value;
        }
        
        return null;
    }

    getFilterOptionByName(optionname: string, sectionName?: string): MdsLax<InstanceType<typeof FilterPanelOption>> {
        for (let section of this.sections) {
            if (section.widget.name === sectionName || !sectionName) {
                let option = section.widget.getFilterOptionByName(optionname);
                
                if (option) {
                    return option;
                }
            }
        }

        return null;    
    }

    getFilterOptions(onlyVisible?: boolean): Array<MdsLax<InstanceType<typeof FilterPanelOption>>> {
        if (!this.sections?.length) return [];

        let options = [];
        for (let section of this.sections) {
            if (onlyVisible !== true || section.widget.getCollapseState() != true ) {
                let optionsOfSection = section.widget.getFilterOptions();
                for (let option of optionsOfSection) {
                    options.push(option);
                }
            }
        }

        return options;
    }

    /**
     * Die erste Filteroption fokussieren (falls Input), oder eine Option mit entsprechendem Namen fokussieren.
     * @param optionname
     */
    focusFirstVisibleOption(optionname?: string, sectionname?: string): void {
        let allOptions = this.getFilterOptions(true);
        let option: MdsLax<InstanceType<typeof FilterPanelOption>> = null;
        let section: MdsLax<InstanceType<typeof FilterPanelSection>> = null;
        if (optionname) {
            option = this.getFilterOptionByName(optionname, sectionname);
        }

        else {
            for (let availableOption of allOptions) {
                let type = availableOption.getType();
                if (
                    type == FilterOptionTypes.date ||
                    type == FilterOptionTypes.text ||
                    type == FilterOptionTypes.float ||
                    type == FilterOptionTypes.number
                ) {
                    option = availableOption;
                    break;
                }
            }
        }

        if (option) {
            section = option.section;
            if (section) section.expand();
            option.focusInput();
        }
    }

    private applyButtonConfig() {
        let data = this.buttonConfig;

        if (data) {

            if (data.buttonLabel) {
                this.buttonLabel.innerHTML = data.buttonLabel;

                if (data.buttonIconClass) {
                    this.leftIconNode.className = data.buttonIconClass;
                }
                this.hideNode(this.leftIconNode, typeof (data.buttonIconClass) != "string");
            }
            this.hideNode(this.buttonContainer, typeof (data.buttonLabel) != "string");
        } else {
            this.hideNode(this.buttonContainer);
        }

    }

    private _onKeyUp_Section(evt: KeyboardEvent) {
        //console.debug("_onKeyUp_Section", evt);
        if (evt.key == "Enter") {
            this.serializeData();
            setTimeout(lang.hitch(this, this._onClickSubmit, evt), 100);
        }
    }
    private _onClickSubmit(evt: MouseEvent) {
        this.emit("submitClick", this.valid);
    }


    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);

    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.sections = [];
        this.name = location.pathname + "-" + this.id;

        if (!this._displaySettings) {
            this._displaySettings = this._loadDisplaySettings();
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
        if (this.domNode) this.domNode.setAttribute("data-cy", "filterpanel:" + this.name);
        if (this.btnSubmit && !this.btnSubmit.getAttribute("data-cy")) {
            this.btnSubmit.setAttribute("data-cy", "filterpanel:" + this.name + ":btnSubmit");
        }
    }
}

export default mdsWidget(FilterPanel);
